module.exports = __webpack_public_path__ + "static/assets/7e8d3b8f91332c4f3b86ab89ce169285.svg";